import React from 'react';
import { motion } from 'framer-motion';
import BackToHomeLink from '../components/BackToHomeLink';

const MentionsLegales = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-beige/10 pt-32 pb-20">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          className="max-w-4xl mx-auto bg-white rounded-2xl shadow-lg p-8 md:p-12 border border-brown/10"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <motion.h1
            className="text-3xl md:text-4xl font-bold text-brown mb-8"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
          >
            Mentions Légales
          </motion.h1>

          <div className="space-y-8 text-gray-700">
            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">1. Présentation du site</h2>
              <p>
                En vertu de l'article 6 de la loi n° 2004-575 du 21 juin 2004 pour la confiance dans l'économie numérique,
                il est précisé aux utilisateurs du site <strong>s.belliard-reynes.fr</strong> l'identité des différents intervenants
                dans le cadre de sa réalisation et de son suivi.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">2. Propriétaire</h2>
              <p><strong>Propriétaire</strong> : Siriane Belliard-Reynes</p>
              <p><strong>Adresse</strong> : 9 rue du Docteur Mourier, 77430 Champagne-sur-Seine</p>
              <p><strong>SIRET</strong> : 853 464 873 00035</p>
              <p><strong>Contact</strong> : neuro.endo.therapeute@gmail.com / 06 36 14 31 26</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">3. Hébergement</h2>
              <p><strong>Hébergeur</strong> : IONOS</p>
              <p><strong>Adresse</strong> : 7 PLACE DE LA GARE, 57200 SARREGUEMINES</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">4. Conditions d'utilisation</h2>
              <p>
                L'utilisation du site implique l'acceptation pleine et entière des conditions générales d'utilisation décrites ci-après.
                Ces conditions d'utilisation sont susceptibles d'être modifiées ou complétées à tout moment, sans préavis.
                Les utilisateurs du site sont donc invités à les consulter de manière régulière.
              </p>
              <p>
                Ce site est normalement accessible à tout moment aux utilisateurs. Une interruption pour raison de maintenance
                technique peut être toutefois décidée, et les horaires d'intervention seront alors indiqués préalablement
                aux utilisateurs si possible.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">5. Propriété intellectuelle</h2>
              <p>
                Siriane Belliard-Reynes est propriétaire des droits de propriété intellectuelle ou détient les droits d'usage
                sur tous les éléments accessibles sur le site, notamment les textes, images, graphismes, logo, icônes, sons, logiciels.
                Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site,
                quel que soit le moyen ou le procédé utilisé, est interdite sans l'autorisation écrite préalable de Siriane Belliard-Reynes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">6. Responsabilité</h2>
              <p>
                Les informations fournies sur le site le sont à titre informatif. L'exactitude, la complétude et l'actualité
                des informations ne peuvent être garanties malgré le soin apporté à leur publication. En conséquence, Siriane Belliard-Reynes
                décline toute responsabilité pour tout dommage résultant notamment d'une imprécision ou inexactitude des informations disponibles.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brown mb-3">7. Liens hypertextes</h2>
              <p>
                Le site peut contenir des liens vers d'autres sites internet ou d'autres ressources disponibles sur Internet.
                Siriane Belliard-Reynes ne dispose d'aucun moyen pour contrôler les sites en connexion avec son site internet et ne répond pas
                de la disponibilité de tels sites et sources externes, ni ne la garantit.
              </p>
            </section>
          </div>

          <motion.div
            className="mt-12 flex justify-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.5 }}
          >
            <BackToHomeLink variant="solid" />
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default MentionsLegales;
